import { render, staticRenderFns } from "./buyer_bids.vue?vue&type=template&id=877a8c54&"
import script from "./buyer_bids.vue?vue&type=script&lang=js&"
export * from "./buyer_bids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports